module.exports = __webpack_public_path__ + "static/img/blackDownIcon1.606971d5.svg";